import {getUnit} from "../../api/rentAndBuy";

const state = () => ({

  rent:{},
  newsId: null
})


const getters = {
  get_rent(state) {
    return state.rent;
  },
}

const mutations = {
  SET_RENT(state,data){
    state.rent = data;}
}

const actions = {
  async fetchRent({ commit }) {
    try {
      const response = await getUnit();
      commit('SET_RENT', response.data);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
